import { render } from "./TabDashboard.vue?vue&type=template&id=20a804aa"
import script from "./TabDashboard.js?vue&type=script&lang=js"
export * from "./TabDashboard.js?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./TabDashboard.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Firshadck%2Fprojects%2Fsunrise-spa%2Fsrc%2Fpresentation%2Ffashion%2FUser%2FTabDashboard%2FTabDashboard.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__